// extracted by mini-css-extract-plugin
export default {"intro":"station-add_intro__NP6Ew","form":"station-add_form__G6E5B","subform":"station-add_subform__K9KHN","continue":"station-add_continue__p7Iqr","error":"station-add_error__rqCBN"};